<template>
	<div class="main-content" v-loading="loading">
		<div class="cart-content" v-if="!loading">
			<div class="cart-title" style="padding: 10px 20px;">购物车</div>
			<div class="step-progress" style="padding: 10px 20px;">
				<div class="step-slider step-active">商品分类<span class="iconfont iconchangjiantou-you"></span></div>
				<div class="step-slider step-active">购物车<span class="iconfont iconchangjiantou-you"></span></div>
				<div class="step-slider">确认订单<span class="iconfont iconchangjiantou-you"></span></div>
				<div class="step-slider">审核订单<span class="iconfont iconchangjiantou-you"></span></div>
				<div class="step-slider">总部受理订单</div>
			</div>
			<div style='padding: 0px 20px;'>
				<el-table :data="tableData" height="700">
					<el-table-column label="选择" type="index" min-width="7%">
						<template slot-scope="scope">
							<div @click="ToggleItemTap(scope.$index)"><span class="iconfont iconxuanzhong" v-if="scope.row.checked=='1'"></span>
								<span class="iconfont iconweibiaoti38" v-else></span></div>
						</template>
					</el-table-column>
					<el-table-column label="操作" min-width="4%">
						<template slot-scope="scope">
							<el-button @click.native.prevent="deleteItem(scope.$index)" type="text" size="small">
								删除
							</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="商品名称" min-width="25%">
					</el-table-column>
					<el-table-column prop="sku_name" label="规格型号" min-width="7%">
					</el-table-column>
					<el-table-column prop="mnemonic_code" label="助记码" min-width="7%">
					</el-table-column>
					<el-table-column prop="barcode" label="条形码" min-width="15%">
					</el-table-column>
					<el-table-column prop="sale_price_unit_qty" label="订货数量" min-width="7%">
						<template slot-scope="scope">
							<el-input placeholder="请输入数量" @change='changeQty(scope.$index,)' v-model="scope.row.sale_price_unit_qty"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="sale_unit" label="计量单位" min-width="7%">
					</el-table-column>
					<el-table-column prop="sale_unit_qty" label="件数" min-width="7%">
						<template slot-scope="scope">
							<el-input placeholder="请输入数量" @change='changeNuitQty(scope.$index,)' v-model="scope.row.sale_unit_qty"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="price" label="单价" min-width="7%">
					</el-table-column>
					<el-table-column prop="subtotal_price" label="金额" min-width="7%">
					</el-table-column>
				</el-table>
			</div>
			<div class="amount-total">
				<div style="display: inline-block;" @click="ToggleAllItemsTap()">全选<span class="iconfont iconxuanzhong mr20 ml10"
					 v-if="dataInfo.is_check_all=='1'"></span>
					<span class="iconfont iconweibiaoti38 mr20 ml10" v-else></span></div>
				<span class="mr20">总件数：{{dataInfo.sale_unit_qty}}</span>
				<span class="mr20">总数量：{{dataInfo.sale_price_unit_qty}}</span>
				<span class="mr20">总金额：<span class="text-red">{{dataInfo.total_price.toFixed(2)}}</span> </span>
				<!-- <button class="bnt-buy"> -->
					<router-link to="cat" class="bnt-buy" replace>继续购买</router-link>
				<!-- </button> -->
				<button class="bnt-submit" @click="confirm()">订单结算</button>
			</div>
		</div>
	</div>
</template>

<script >
	import Vheader from '@/views/header'
	export default {
		name: 'cart-content',
		data() {
			return {
				tableData: [],
				loading: true,
				dataInfo: {}
			}
		},
		created: function() {
			this.reload();
		},

		methods: {
			confirm: function() {
				var me = this;
				const request = function(){
					me.https.fetchGet('/pc/service/trade/cart/settle').then((res) => {
						if (res.data.success) {
							me.$router.push('pay');
						} else {
							me.$alert(res.data.message, '提示', {
								confirmButtonText: '查看订单',
								callback: action => {
									if (action === 'confirm') {
										me.$router.push({
											name: 'orderlist',
											query: {
												status: '30'
											}
										})
									}
								}
							});
						}
					}).catch(err => {
						console.log(err)
					})
				}
				for(var i in this.tableData){
					if(this.tableData[i].checked=='1'){
						request();
						console.log('111111',this.tableData[i].checked)
						return;
					}
				}
				this.$message({
					type: 'warning',
					message: '请选择商品'
				});



			},
			reload: function() {
				var me = this;
				this.https.fetchGet('/pc/service/trade/cart/index').then((res) => {
					if (res.data.success) {
						var data = res.data.content;
						me.tableData = data.rows;
						me.loading = false;
						me.dataInfo = data;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			deleteItem: function(index) {
				var params = {
					cart_id: this.tableData[index].cart_id
				}
				var me = this;
				this.$confirm('是否要删除该商品', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					me.https.fetchPost('/pc/service/trade/cart/delete-item', params).then((res) => {
						if (res.data.success) {
							me.reload();
							me.$message({
								type: 'success',
								message: '删除成功'
							});
							Vheader.methods.getCartItemsCount();
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {

				});

			},
			//数量加减
			changeQty: function(index) {
				var sale_price_unit_qty = this.tableData[index].sale_price_unit_qty;
				if (sale_price_unit_qty < 1 || sale_price_unit_qty == '') {
					sale_price_unit_qty = 1;
				}
				sale_price_unit_qty = parseInt(sale_price_unit_qty);
				var sale_unit_qty = (sale_price_unit_qty / this.tableData[index].convert_numerator).toFixed(2);
				this.tableData[index].sale_unit_qty = sale_unit_qty;
				this.tableData[index].sale_price_unit_qty = sale_price_unit_qty;
				var params = {
					cart_id: this.tableData[index].cart_id,
					sale_unit_qty: sale_unit_qty,
					sale_price_unit_qty: sale_price_unit_qty,
					checked: this.tableData[index].checked
				}
				this.updataCart(params);
			},
			changeNuitQty: function(index) {
				var sale_unit_qty = this.tableData[index].sale_unit_qty;
				var sale_price_unit_qty = 0;
				if (sale_unit_qty > 0) {
					sale_price_unit_qty = parseInt(sale_unit_qty * this.tableData[index].convert_numerator);
				} else {
					sale_unit_qty = 0;
				}
				this.tableData[index].sale_unit_qty = sale_unit_qty;
				this.tableData[index].sale_price_unit_qty = sale_price_unit_qty;
				var params = {
					cart_id: this.tableData[index].cart_id,
					sale_unit_qty: sale_unit_qty,
					sale_price_unit_qty: sale_price_unit_qty,
					checked: this.tableData[index].checked
				}
				this.updataCart(params);
			},

			//选择商品
			ToggleItemTap: function(index) {
				this.tableData[index].checked = this.tableData[index].checked == '0' ? '1' : '0';
				var params = {
					cart_id: this.tableData[index].cart_id,
					sale_unit_qty: this.tableData[index].sale_unit_qty,
					sale_price_unit_qty: this.tableData[index].sale_price_unit_qty,
					checked: this.tableData[index].checked
				}
				this.updataCart(params);
			},
			updataCart: function(params) {
				this.https.fetchPost('/pc/service/trade/cart/update-item', params).then((res) => {
					if (res.data.success) {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.reload();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//全选
			ToggleAllItemsTap: function() {
				var value = this.dataInfo.is_check_all == '1' ? 0 : 1;
				var params = {
					value: value
				}
				this.https.fetchPost('/pc/service/trade/cart/check', params).then((res) => {
					if (res.data.success) {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.reload();
					}
				}).catch(err => {
					console.log(err)
				})
			}


		}
	}
</script>

<style >
	.cart-content {
		background: #fff;
		padding: 20px;
	}

	/* .main-content {
		padding: 20px;
	} */

	.el-table td {
		text-align: center !important;
	}

	.el-table__header th {
		background-color: rgb(74, 144, 138) !important;
		color: #fff;
		text-align: center!important;
	}

	.step-progress {
		float: right;
		padding-right: 20px;
	}

	.cart-title {
		display: inline-block;
		padding: 10px 20px;
	}

	.amount-total {
		text-align: right;
		height: 50px;
		margin-right: 50px;
		margin-top: 20px;
	}

	.bnt-buy {
		background: rgb(74, 144, 138);
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.bnt-submit {
		background: red;
		color: #fff;
		border: 0;
		padding: 10px 30px;
		cursor: pointer;
		border-radius: 5px;
	}

	.mr20 {
		margin-right: 20px;
	}

	.ml10 {
		margin-left: 10px;
	}

	.text-red {
		color: red;
	}

	.iconxuanzhong {
		color: red;
		font-size: 20px;
		cursor: pointer;
	}

	.iconweibiaoti38 {
		font-size: 20px;
		cursor: pointer;
	}
/* 	.el-table::before{height: 0px !important;}
	.el-table--border::after, .el-table--group::after{width:0px !important;} */
</style>



// WEBPACK FOOTER //
// src/views/cart.vue